<script setup lang="ts">
import { ref, computed, watch, onUnmounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { useDynamicBreadcrumb } from '@/composables/navigation/useBreadcrumbs'

const { t } = useI18n({ useScope: 'global' })
const { setDynamicBreadcrumb } = useDynamicBreadcrumb()

// to do when its ready
const selectedTabs = ref(0)
const _integrationTabs = computed(() => {
  //sooon  t('sip_trunk'), t('web_rtc')
  return [t('api_keys')]
})

// Update breadcrumb when tab changes - pass translation key, not translated value
const breadcrumbKeys = ['api_keys']
watch(
  selectedTabs,
  (newTab) => {
    setDynamicBreadcrumb(breadcrumbKeys[newTab])
  },
  { immediate: true },
)

// Clean up breadcrumb when leaving the component
onUnmounted(() => {
  setDynamicBreadcrumb(null)
})
</script>

<template>
  <div class="px-10 pb-10 pt-10">
    <ApiKeys />
    <!--      <OTabs-->
    <!--        class="flex-1"-->
    <!--        v-model="selectedTabs"-->
    <!--        :tabs="integrationTabs"-->
    <!--        data-testid="configurator-tabs"-->
    <!--      >-->
    <!--        <TabPanel :active="selectedTabs === 0">-->
    <!--          <span>API keys</span>-->
    <!--        </TabPanel>-->
    <!--        <TabPanel :active="selectedTabs === 1" class="overflow-y-auto">-->
    <!--          <span>SIP TRUNK</span>-->
    <!--        </TabPanel>-->
    <!--        <TabPanel :active="selectedTabs === 2">-->
    <!--          <span>WEB RTC</span>-->
    <!--        </TabPanel>-->
    <!--      </OTabs>-->
  </div>
</template>
